import { render } from "./list-detail-panel-empty.vue?vue&type=template&id=508fd5cb&scoped=true&ts=true"
import script from "./list-detail-panel-empty.vue?vue&type=script&lang=ts"
export * from "./list-detail-panel-empty.vue?vue&type=script&lang=ts"

import "./list-detail-panel-empty.vue?vue&type=style&index=0&id=508fd5cb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508fd5cb"]])

export default __exports__